'use client'

import { PropsWithChildren } from 'react';
// import MenuProfile from '../Components/Layout/MenuProfile';

const DefaultLayoutProfile = ({
  children,
}: PropsWithChildren) => {

  return (
    <div className="flex flex-col md:flex-row gap-4">
      {/* <section className="flex flex-col max-h-max w-full md:max-w-max rounded-lg bg-gray-50">
          <MenuProfile />
      </section> */}
      <section className="w-full p-0 rounded-xl">
        { children }
      </section>
  </div>
  )
}

export default DefaultLayoutProfile;